import axios from "axios";
import {ResponseFile, ResponseList} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EDQuestion} from "../../models/serverModels/education/EDQuestion";

const education = axios.create({
  baseURL: "/API",
});

type EditExamProps = {
  id: string | undefined;
  token: string;
};

export const getList = async (params: EditExamProps): Promise<ResponseList<EDQuestion>> =>
  education({
    url: `/questionList/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const update = async (
  params: Params.UpdateList<EDQuestion>
): Promise<ResponseList<EDQuestion>> =>
  education({
    url: `/QuestionList/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const ImportQuestions = async (params: Params.ImportFile): Promise<ResponseFile> =>
  education({
    url: `/ImportQuestions`,
    method: "post",
    data: params,
  }).then((res) => res.data);
